import { formatMessage as f } from '@/i18n';

export default () => {
  return {
    LITE: f('system.about.edition.lit'),
    STD: f('system.about.edition.std'),
    ENT: f('system.about.edition.ent'),
  };
};
